import React, { FC, memo } from 'react'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import Gallery from '../../LayoutInstitution/desktop/GalleryComponent'
import InfrastructureMap from '../components/InfrastructureMap'
import InfrastructureList from './InfrastructureList'

import { IInstitutionCampusProps } from '../types'

const InstitutionCampus: FC<IInstitutionCampusProps> = (props) => {
  const { description, campus, mediaList } = props

  return (
    <>
      <Heading h2='Кампус и инфраструктура' spacing='small' />

      {!!mediaList?.length && (
        <>
          <Spacing spacing='large' />

          <Gallery mediaList={mediaList} />

          <Spacing spacing='xlarge' />
        </>
      )}

      {description && (
        <>
          <Text>{description}</Text>

          <Spacing spacing='xlarge' />
        </>
      )}

      {!!campus.length && <InfrastructureList campus={campus} />}

      {!!campus.length && <InfrastructureMap campus={campus} />}
    </>
  )
}

export default memo(InstitutionCampus)
